module.exports = __webpack_public_path__ + "assets/tenBis-gov-logo-ef35b9.svg";